<main class="peca-kanban">
  <ng-content></ng-content>
</main>
